import { Modal, Form, Input, Button } from "antd";
import { useEffect } from "react";

interface AddSourceModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (sourceName: string) => Promise<void> | void;
  loading?: boolean;
  initialSourceName?: string;
  mode?: "add" | "edit";
}

const AddSourceModal = ({
  open,
  onClose,
  onSubmit,
  loading = false,
  initialSourceName = "",
  mode = "add",
}: AddSourceModalProps) => {
  const [form] = Form.useForm<{ sourceName: string }>();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ sourceName: initialSourceName });
      return;
    }

    form.resetFields();
  }, [open, initialSourceName, form]);

  const handleFinish = async (values: { sourceName: string }) => {
    await onSubmit(values.sourceName);
  };

  return (
    <Modal
      title={
        <span className="text-xl font-normal text-gray-800">
          {mode === "edit" ? "Edit Source" : "Add Source"}
        </span>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={<span className="text-xl text-gray-800">x</span>}
      centered
      width={750}
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        className="mt-4"
        onFinish={handleFinish}
      >
        <Form.Item
          label={<span className="text-gray-800 font-medium">Source Name</span>}
          name="sourceName"
          rules={[
            { required: true, message: "Source Name is required" },
            { whitespace: true, message: "Source Name is required" },
          ]}
        >
          <Input
            size="large"
            placeholder="Source Name"
            className="w-full rounded-md"
          />
        </Form.Item>

        <div className="flex justify-end gap-4 mt-12">
          <Button
            onClick={onClose}
            className="h-9 px-8  rounded-lg border-none bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium"
          >
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className="h-9 px-8 rounded-lg bg-[#004aad] hover:bg-blue-800 border-none text-white font-medium"
          >
            {mode === "edit" ? "Update" : "Add"}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddSourceModal;
